export default __webpack_public_path__ + "media/images/features/local_delivery/episode4/LP_01-2a89622fabe4b61d86b09547978c6471.jpg";